import React, { useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import { version } from 'config';
import { ProjectContext } from 'contexts/ProjectContext';
import { BRAND_NAME } from 'helpers/brand';

const Footer = () => {
  const projectContext = useContext(ProjectContext);
  const currentProject = projectContext?.currentProject;
  // Имя проекта берётся из currentProject (мультитенантность — для каждого
  // проекта своё имя). Fallback BRAND_NAME = «Админ-панель» — только когда
  // currentProject ещё не загружен / нет ProjectProvider (auth-pages).
  // Ссылка футера — ТОЛЬКО из project_data.footer_link конкретного проекта;
  // env-fallback'а нет (вёл бы к per-deploy брендингу одного проекта).
  const projectName = currentProject?.name || BRAND_NAME;
  const footerLink = currentProject?.project_data?.footer_link || '';

  return (
    <footer className="footer">
      <Row className="justify-content-between text-center fs-10 mt-4 mb-3">
        <Col sm="auto">
          <p className="mb-0 text-600">
            Бэкофис для {projectName}{' '}
            <span className="d-none d-sm-inline-block">| </span>
            <br className="d-sm-none" /> {new Date().getFullYear()} &copy;{' '}
            {footerLink ? (
              <a href={footerLink} target="_blank" rel="noopener noreferrer">
                {projectName}
              </a>
            ) : (
              projectName
            )}
          </p>
        </Col>
        <Col sm="auto">
          <p className="mb-0 text-600">v{version}</p>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
